import { AuthGuard } from '../../../shared/services';
import { UserDetailsComponent } from './user-details.component';
import { UserDetailsResolver } from './user-details.resolver';
import { Route } from '@angular/router';

export const UserDetailsRoutes: Route[] = [
  {
    path: 'details/:id',
    component: UserDetailsComponent,
    canActivate: [AuthGuard],
    resolve: {
      user: UserDetailsResolver
    }
  }
];
